import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import { useLang } from '../contexts/LangContext';

const CONSENT_KEY = 'hafizim_consent';

const CookieConsent = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(() => {
    try {
      return !localStorage.getItem(CONSENT_KEY);
    } catch (_) {
      return true;
    }
  });

  const accept = () => {
    try { localStorage.setItem(CONSENT_KEY, JSON.stringify({ accepted: true, ts: Date.now() })); } catch (_) { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-consent-banner"
      className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-6 sm:bottom-6 z-[60] max-w-md bg-white border border-stone-200 rounded-2xl shadow-xl p-4 sm:p-5"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-700 flex items-center justify-center flex-shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-stone-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {lang === 'tr' ? 'Çerez ve Yerel Depolama' : 'Cookies & Local Storage'}
          </p>
          <p className="text-xs text-stone-600 mt-1 leading-relaxed">
            {lang === 'tr' ? (
              <>Hafızım, oturum açma ve tercihlerinizi hatırlamak için tarayıcınızda küçük veriler saklar. Üçüncü taraf izleyici, reklam veya analitik <strong>kullanılmaz</strong>. Detaylar için </>
            ) : (
              <>We store small data in your browser to keep you signed in and remember preferences. No 3rd-party tracking. See </>
            )}
            <Link to="/cerez-politikasi" className="text-teal-700 underline font-medium" data-testid="cookie-link-policy">
              {lang === 'tr' ? 'Çerez Politikası' : 'Cookie Policy'}
            </Link>
            {lang === 'tr' ? ' ve ' : ' and '}
            <Link to="/gizlilik-politikasi" className="text-teal-700 underline font-medium" data-testid="cookie-link-privacy">
              {lang === 'tr' ? 'Gizlilik Politikası' : 'Privacy Policy'}
            </Link>.
          </p>
          <div className="mt-3 flex items-center gap-2">
            <button
              type="button"
              onClick={accept}
              data-testid="cookie-accept-btn"
              className="px-4 py-2 rounded-xl bg-teal-700 hover:bg-teal-800 text-white text-sm font-semibold transition-colors"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              {lang === 'tr' ? 'Anladım, devam et' : 'Got it'}
            </button>
            <button
              type="button"
              onClick={() => setVisible(false)}
              data-testid="cookie-dismiss-btn"
              className="p-2 rounded-xl text-stone-500 hover:bg-stone-100"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
